import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { upsertStoreProductReapproParam } from '../mutations/storeProductReapproParams.mutations'
import { fetchStoreProductReapproParams } from '../queries/storeProductReapproParams.queries'

export const useStoreProductReapproParams = (storeId: number, reapproCategoryId: number) =>
  useQuery({
    queryKey: ['storeProductReapproParams', storeId, reapproCategoryId],
    queryFn: () => fetchStoreProductReapproParams(storeId, reapproCategoryId),
  })

export const useUpsertStoreProductReapproParam = (storeId: number, reapproCategoryId: number) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: upsertStoreProductReapproParam,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['storeProductReapproParams', storeId, reapproCategoryId],
      })
    },
  })
}
